import React from 'react';
import ModalSheet from '@boschebike/ebds-react/dist-esm/components/ModalSheet.js';
import Button from '@boschebike/ebds-react/dist-esm/components/Button.js';
import Container from '@boschebike/ebds-react/dist-esm/components/Container.js';

interface ButtonProps {
  buttonText: string;
  buttonSrText?: string;
  href?: string;
}

interface WelcomeModalSheetProps {
  headline: string;
  line1: string;
  image?: {
    src: string;
    title?: string;
    width: number;
    height: number;
  };
  button: ButtonProps;
  dispatchHide: () => void;
  secondaryButton?: ButtonProps;
}

const WelcomeModalSheet: React.FC<WelcomeModalSheetProps> = ({
  headline,
  line1,
  image,
  button,
  dispatchHide,
  secondaryButton = null
}) => {
  const modalIllustration = image ? (
    <div className='goose-modal-welcome-message__content__body__illustration'>
      <img src={image.src} alt={image.title ?? ''} width={image.width} height={image.height} />
    </div>
  ) : null;

  const primaryOnClick = React.useCallback(() => {
    dispatchHide();

    if (button.href) {
      globalThis.location.href = button.href;
    }
  }, [dispatchHide, button]);

  const primaryBtn = button.buttonText ? (
    <Button
      name='goose-welcome-message-primary-button'
      id='goose-welcome-message-primary-button'
      data-testid='welcome-message-primary-button'
      text={button.buttonText}
      srText={button.buttonSrText ?? button.buttonText}
      type='button'
      mode='primary'
      onClick={primaryOnClick}
    ></Button>
  ) : null;

  const secondaryOnClick = React.useCallback(() => {
    dispatchHide();

    if (secondaryButton?.href) {
      globalThis.location.href = secondaryButton.href;
    }
  }, [dispatchHide, secondaryButton]);

  const secondaryBtn = secondaryButton?.buttonText ? (
    <Button
      name="goose-welcome-message-secondary-button"
      id="goose-welcome-message-secondary-button"
      data-testid="welcome-message-secondary-button"
      text={secondaryButton.buttonText}
      srText={secondaryButton.buttonSrText ?? secondaryButton.buttonText}
      type="button"
      mode="tertiary"
      onClick={secondaryOnClick}
    ></Button>
  ) : null;

  return (
    <ModalSheet.Content type='gooseWelcomeMessage'>
      <Container customContentClassName='goose-modal-welcome-message'>
        <div className='goose-modal-welcome-message__content__body'
          data-testid='modal-welcome-message'>
          {modalIllustration}
          <div className='goose-modal-welcome-message__content__body__text'>
            <h3>{headline}</h3>
            <p dangerouslySetInnerHTML={{ __html: line1 }} />
          </div>
          <div className='goose-modal-welcome-message__content__body__actions'>
            {primaryBtn}
            {secondaryBtn}
          </div>
        </div>
      </Container>
    </ModalSheet.Content>
  );
};

export default WelcomeModalSheet;
